import moment from 'moment';
import { HTTP } from './xhr';
import { sprintf } from 'sprintf-js';
import interact from 'interactjs';
import { StorageTab } from './storagetab';
import { BlockChangeEvent, BlockDoubleClickEvent, SlotDoubleClickEvent, BlockContextMenuClickEvent } from './events';

export class Calendar {

  $element = undefined;

  cancelLastClick = false;

  lastEventSet = [];

  events = [];
  selectedTabValue = 0;

  days = [];

  listeners = {
    "calendar.block.change": [],
    "calendar.slot.dblclick": [],
    "calendar.block.dblclick": [],
    "calendar.block.click": [],
    "calendar.block.contextmenu.click": []
  };

  occupiedData = {};

  options = {
    start_date: moment().startOf("week").format("YYYY-MM-DD"),
    selected_date: null,
    startup_minute: null,
    startup_other: null,
    container: 'body',
    cellHeight: 50,
    days_to_display: 1,
    viewMode: false,
    hashingBackground: "",
    excludeDays: [0, 6],
    bays: [{
        id: 1,
        name: "Bay 1",
        first: true,
        last: false
      },
      {
        id: 2,
        name: "Bay 2",
        first: false,
        last: true
      }
    ],
    dayCells: [{
        type: "time",
        step: 15,
        start_minute: 420,
        duration: 300
      },
      {
        type: "other",
        label: "Autre 1",
        index: 1
      },
      {
        type: "other",
        label: "Autre 2",
        index: 2
      },
      {
        type: "other",
        label: "Autre 3",
        index: 3
      },
      {
        type: "time",
        step: 15,
        start_minute: 780,
        duration: 240
      },
      {
        type: "other",
        label: "Autre 4",
        index: 4
      },
      {
        type: "other",
        label: "Autre 5",
        index: 5
      }
    ],
    statuses: [],
    onFetch: function (callback) {
      let rand = parseInt(Math.random() * 100000);
      HTTP.get("http://192.168.1.206/jsplugins/garage_calendar/events.json?r=" + rand, response => {
        callback(JSON.parse(response));
      })
    }
  }

  tabs = {};

  constructor($element, options) {
    let that = this;
    this.$element = $element;
    this.options.selected_date = this.options.start_date;
    Object.assign(this.options, options);
    moment.locale("fr");

    this.tabs["toschedule"] = new StorageTab("#gc-tabs", {
      id: "toschedule",
      name: "À céduler"
    })

    this.refetchEvents(function () {
      that.drawCalendar();
      that.setupListeners();
    });
    this.setupDraggable();
    return this;
  }

  on(name, callback) {
    if (this.listeners[name] === undefined) {
      console.error("Event '" + name + "' does not exist!");
      return this;
    }
    this.listeners[name].push(callback);
    return this;
  }

  dispatchEvent(name, event, data) {
    let listeners = this.listeners[name];
    for (const listener of listeners) {
      listener(event, data);
    }
  }

  toggleTab(id) {
    let tab = this.tabs[id];
    if (tab !== undefined) {
      tab.toggleTab();
    }
  }

  openTab(id) {
    let tab = this.tabs[id];
    if (tab !== undefined) {
      tab.openTab();
    }
  }

  getEvents() {
    return this.events;
  }

  isSoumissionState(event) {
    if (event == null) {
      return true;
    }

    let stateId = parseInt(event.invoice_invoice_state_id ?? event.invoice_state_id ?? 0, 10);
    return !isNaN(stateId) && stateId === -1;
  }

  isUnscheduledEvent(event) {
    if (event == null) {
      return false;
    }

    let bay = parseInt(event.bay ?? 0, 10);
    return event.date == null || isNaN(bay) || bay === 0;
  }

  isToScheduleEvent(event) {
    if (event == null) {
      return false;
    }

    return !this.isSoumissionState(event) && this.isUnscheduledEvent(event);
  }

  addEvent(event) {
    this.events.push(event);
    this.moveEventTab(event, event.tabid);
  }

  removeEvents(ids) {
    for (let id of ids) {
      this.removeEvent(id);
    }
  }

  removeEvent(id) {
    for (let tabName in this.tabs) {
      this.tabs[tabName].removeEvent(id);
    }

    this.events = this.events.filter(e => {
      return parseInt(e.id) !== id;
    })
  }

  editEvent(event_id, data) {
    let event = this.findEvent(event_id);
    if (event !== undefined) {
      let eventWithUpdatedData = Object.assign({}, event, data, {
        tabid: event.tabid
      });

      let resolvedTabId = this.moveEventTab(eventWithUpdatedData, data.tabid);
      Object.assign(event, data, {
        tabid: resolvedTabId
      });
      return true;
    }
    return false;
  }

  reloadEvents() {
    let that = this;
    this.refetchEvents(function () {
      that.redrawEvents();
      that.updateOccupiedDisplay();
    });
  }

  refetchEvents(callback) {
    if (callback === undefined) callback = function (events) {};
    let that = this;
    this.options.onFetch(function (events) {
      that.events = events;

      for (let tabName in that.tabs) {
        that.tabs[tabName].clearEvents();
      }

      that.events.forEach(e => {
        if ((e.date == null || e.bay == 0) && that.isToScheduleEvent(e)) {
          e.tabid = "toschedule";
          that.tabs["toschedule"].addEvent(e);
        }
      })

      callback(events);
    });
  }

  drawCalendar() {
    let that = this;
    this.refreshColumnData();
    let compiledRows = this.getCompiledRows();
    let compiledDays = this.getCompiledDays();
    this.$element.innerHTML = require("./templates/calendar.hbs")({
      rows: compiledRows,
      days: compiledDays,
      dayColumns: that.getFilteredBays(),
      cellHeight: that.options.cellHeight,
      totalWidth: 260 * compiledDays.length * that.getFilteredBays().length + 1,
      totalHeight: that.options.contentHeight
    });
    this.drawTabs();
    this.drawEvents();
    for (let tabName in this.tabs) {
      this.tabs[tabName].resetLastSet();
    }
    this.updateCalendarHeaderPosition();
  }

  getFilteredBays() {
    //filter bays
    var selected_bay = localStorage["selected_bay"] !== undefined ? localStorage["selected_bay"] : 0;
    let bays = this.options.bays;
    if (!selected_bay || selected_bay=="" || selected_bay == null || selected_bay == "null" || selected_bay === undefined || selected_bay === 0)
    {
      return bays;
    }
    return bays.filter(item => selected_bay.indexOf(item.id) > -1);
  }

  scrollToMinute(minute) {
    let offset = $(this.$element).find(".gc-details[minute='" + minute + "']").first().position().top;
    $(this.options.container).scrollTop(offset - 200);
  }

  scrollToOther(other) {
    let offset = $(this.$element).find(".gc-details[other='" + other + "']").first().position().top;
    $(this.options.container).scrollTop(offset - 200);
  }

  scrollToDate(date) {
    var position = $(this.$element).find(".gc-header-date[date='" + date + "']").first().position();
    let offset = position === undefined ? 0 : position.left;
    $(this.options.container).scrollLeft(offset - 500);
  }

  drawTabs() {
    for (let tabName in this.tabs) {
      this.tabs[tabName].drawTab();
    }
  }

  drawEvents() {
    let that = this;
    let events = this.events;

    events = events.sort((a, b) => {
      let str_a = a.date + "_" + a.minute + "_" + a.bay;
      let str_b = b.date + "_" + b.minute + "_" + b.bay;
      return str_a.localeCompare(str_b);
    });

    events.forEach(e => {
      that.drawEvent(e.id);
    })

    for (let tabName in this.tabs) {
      this.tabs[tabName].drawEvents();
    }

    if (this.options.startup_minute == "") this.options.startup_minute = null;
    if (this.options.startup_minute !== null) {
      this.scrollToMinute(this.options.startup_minute);
      this.options.startup_minute = null;
    }

    if (this.options.startup_other == "") this.options.startup_other = null;
    if (this.options.startup_other !== null) {
      this.scrollToOther(this.options.startup_other);
      this.options.startup_other = null;
    }

    if (!that.viewMode) {
      var items = {};

      that.options.statuses.forEach(status => {
        items["stat" + status.id] = {
          name: status.name,
          icon: "fa-tag",
          className: "context_status_"+ status.id,
          callback: function (key, opt) {
            let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
            if (!(eventid > 0)) { //ignore background events
              that.redrawEvents();
              return;
            }

            let apply = function () {
            that.lastEventSet = JSON.parse(JSON.stringify(that.events));
            
            {
              let event = that.findEvent(eventid);
              event.invoice_invoice_state_id = status.id;

              let evt2 = new BlockContextMenuClickEvent();
              evt2.calendar = that;
              evt2.block = event;
              evt2.clickedOption = opt;
              evt2.clickedOptionName = "stat" + status.id;
              that.dispatchEvent("calendar.block.contextmenu.click", evt2);

              let evt = new BlockChangeEvent();
              evt.calendar = that;
              evt.block = event;
              that.dispatchEvent("calendar.block.change", evt)

              let parentEventId = event.invoice_invoice_id == null ? event.invoice_id : event.invoice_invoice_id;

              that.events.forEach(e => {
                if (parseInt(e.invoice_invoice_id) == parentEventId || parseInt(e.invoice_id) == parentEventId) {
                  e.color = status.color;
                }
              })
            }
            that.redrawEvents();
            };

            let before = that.options.beforeStatusChange;
            if (typeof before === "function") {
              before(that.findEvent(eventid), status, apply);
            } else {
              apply();
            }
          }
        }
      })

      items["sep1"] = {
        "type": "cm_separator"
      }

      items["view"] = {
        name: "Détails",
        icon: "fa-eye",
        className: "bold",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "view";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["sep3"] = {
        "type": "cm_separator"
      }

      items["modify"] = {
        name: "Modifier détails",
        icon: "fa-edit",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "edit";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["modify_services"] = {
        name: "Modifier services",
        icon: "fa-edit",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "edit_services";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["divide"] = {
        name: "Diviser",
        icon: "fa-cut",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "divide";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["sep2"] = {
        "type": "cm_separator"
      }

      items["other_invoice"] = {
        name: "Autre bon de travail",
        icon: "fa-copy",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "other_invoice";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["create_quote"] = {
        name: "Créer soumission",
        icon: "fa-file",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "create_quote";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      items["delete"] = {
        name: "Supprimer",
        icon: "fa-trash",
        className: "font-red bold",
        callback: function (key, opt) {
          let eventid = parseInt(opt.$trigger[0].getAttribute("event-id"));
          let block = that.findEvent(eventid);

          let evt = new BlockContextMenuClickEvent();
          evt.calendar = that;
          evt.block = block;
          evt.clickedOption = opt;
          evt.clickedOptionName = "delete";
          that.dispatchEvent("calendar.block.contextmenu.click", evt);
        }
      }

      $.contextMenu({
        selector: ".gc-details-event",
        items: items
      });
    }

  }

  /**
   * Fonction pour obtenir les morceaux de bon de travail.
   */
  getEventChunks(event_id) {
    let event = this.findEvent(event_id);
    if (event.date == null) return [];
    let datetime = moment(event.date);
    let duration = event.duration;
    let minute = parseInt(event.minute / 15) * 15; // Début

    let remainingMinutes = duration;
    let results = [];

    let ranges = this.options.dayCells.filter(e => e.type == "time");
    let rangeIndex = ranges.findIndex(e => minute >= e.start_minute && minute <= e.start_minute + e.duration);

    while (remainingMinutes > 0 && rangeIndex >= 0) {
      let currentRange = ranges[rangeIndex];
      let start = currentRange.start_minute;
      let end = currentRange.start_minute + currentRange.duration;

      if (results.length == 0) {
        start = minute;
      }

      if ((end - start) >= remainingMinutes) {
        end = start + remainingMinutes;
      }

      results.push({
        start: start,
        end: end,
        duration: end - start,
        date: datetime.format("YYYY-MM-DD")
      })

      remainingMinutes -= (end - start);

      rangeIndex++;
      if (rangeIndex > ranges.length - 1) {
        datetime.add(1, "day");
        while (this.options.excludeDays.indexOf(datetime.day()) !== -1) {
          datetime.add(1, 'day');
        }
        rangeIndex = 0;
      }
    }

    return results;
  }

  getEventPopoverHTML(event) {
    let titletext = "";

    if(event.details && event.details.length > 0){

      titletext += `
        <div><b>${event.customer_name}</b></div>
        <div>${event.vehicle_display}</div>
        <div style="color: red">${event.description.toString().replace(/\n/g, "<br />")}</div>
      `.trim();

      titletext += `<ul style="padding-left: 10px; margin-top: 5px">`;
      event.details.forEach(svc => {
        if (!svc.item_description.replaceAll) svc.item_description = "";
        titletext += `
          <li class="${svc.is_done == "1" ? "is-done" : ""}">
            <b>${svc.item_name}</b><br>
            <span>${svc.item_description.replaceAll("\n", "<br>")}</span>
            <ul>
              ${svc.parts.map(e => `<li>${e.part_name}</li>`).join("")}
            </ul>
          </li>
        `.trim();
      });
      titletext += "</ul>";

    } else {
      titletext += `<div style="color: red">${event.description.toString().replace(/\n/g, "<br />")}</div>`
      titletext += "Aucun service";
    }

    return titletext;
  }

  drawEvent(event_id) {
    let event = this.findEvent(event_id);
    let other = event.other;
    if (other == 0) {

      let chunks = this.getEventChunks(event.id);

      for (let ix in chunks) {
        let chunk = chunks[ix];

        for (let m = chunk.start; m < chunk.end; m += 15) {
          let $elements = this.findTableTdByCriterias(chunk.date, event.bay, m, other);
          if ($elements.$hour != null) {
            $elements.$hour.style.backgroundColor = event.color;
            if (event.rendering == "background" ) { 
              let detailtd = $($elements.$hour).next('td');
              if (detailtd && detailtd[0]) {
                detailtd.addClass('closed-hour'); 
                detailtd.prop('title', event.description);
              }
            }
            $elements.$hour.style.color = event.forecolor;
          }
        }

        let elements = this.findTableTdByCriterias(chunk.date, event.bay, chunk.start, other);
        let durationText = sprintf("%02d:%02d", event.duration / 60, event.duration % 60);

        let hasInspectionWarnings = false;
        let hasPartsToPurchase = false;
        let hasPartsToReceive = false;
      
        if (event.has_inspection_warnings) {
          hasInspectionWarnings = true;
        }
  
        if (event.details && event.details != null) {
          for (const d of event.details) {
            if (d.invoice_detail_parts_status == "1") {
              hasPartsToPurchase = true;
            }
            if (d.invoice_detail_parts_status == "2") {
              hasPartsToReceive = true;
            }
          }
        }

        if (elements.$details != null) {
          let elementHeight = this.options.cellHeight * (chunk.duration / 15);
          let titletext = this.getEventPopoverHTML(event);

          let durationColor = "rgb(71, 255, 111)";
          if(hasPartsToPurchase){
            durationColor = "rgb(255, 92, 92)";
          } else if(hasPartsToReceive){
            durationColor = "rgb(255, 235, 92)";
          }

          let durationBackgroundColor = "#444";
          if(hasInspectionWarnings){
            durationBackgroundColor = "#a70000";
          }
          if (event.rendering != "background" ) { 
            elements.$details.innerHTML = require('./templates/event.hbs')({
              background: false,
              title: titletext,
              customer: event.customer_name,
              event: event,
              description: event.description.toString().replace(/\n/g, "<br />"),
              details: event.details,
              height: elementHeight - 1,
              color: event.color,
              forecolor: event.forecolor,
              id: event.id,
              enableResize: chunks.length == 1 || ix == chunks.length - 1,
              enableDraggable: event.rendering!='background', // && ix == 0,
              displayDetails: event.rendering!='background' && ix == 0,
              cellHeight: this.options.cellHeight,
              durationText: durationText,
              hasInspectionWarnings: hasInspectionWarnings,
              hasPartsToPurchase: hasPartsToPurchase,
              hasPartsToReceive: hasPartsToReceive,
              durationColor: durationColor,
              durationBackgroundColor: durationBackgroundColor,
              isLinked: event.is_linked,
              linkedno: event.linked_no,
              continuationBottom: ix != chunks.length - 1 && chunks.length > 1,
              continuationTop: ix != 0 && chunks.length > 1
            })
          }
        }

      }

    } else {
      let elements = this.findTableTdByCriterias(event.date, event.bay, event.start, other);
      if (elements.$details != null) {
        elements.$details.style.backgroundColor = event.color;
        elements.$details.style.color = event.forecolor;
        elements.$hour.style.backgroundColor = event.color;
        elements.$hour.style.color = event.forecolor;
        //elements.$hour.classList.add("in-use")

        let hasPartsToPurchase = false;
        event.details.forEach(d => {
          if (d.invoice_detail_parts_status == "1") {
            hasPartsToPurchase = true;
          }
        })
        
        let titletext = this.getEventPopoverHTML(event);

        elements.$details.innerHTML = require('./templates/event.hbs')({
          title: titletext,
          customer: event.customer_name,
          event: event,
          description: event.description.toString().replace(/\n/g, "<br />"),
          details: event.details,
          height: this.options.cellHeight,
          color: event.color,
          forecolor: event.forecolor,
          id: event.id,
          enableResize: false,
          enableDraggable: true,
          displayDetails: true,
          cellHeight: this.options.cellHeight,
          hasPartsToPurchase: hasPartsToPurchase,
          isLinked: event.is_linked,
          linkedno: event.linked_no
        })
      }
    }

    $(".popover").detach();

    $(".gc-popover").popover();

  }

  isDatetimeInRange(moment) {
    if (moment.day() == 6 || moment.day() == 5) {
      return false;
    }
    let minute = moment.hour() * 60 + moment.minute();
    for (let ix in this.options.dayCells) {
      let r = this.options.dayCells[ix];
      if (minute >= r.start_minute && minute <= r.start_minute + r.duration) {
        return true;
      }
    }
    return false;
  }

  redrawEvents() {
    this.$element.querySelectorAll(".gc-hour").forEach(e => {
      e.style.backgroundColor = "";
      e.style.color = "";
      //e.classList.remove("in-use")
    })
    this.$element.querySelectorAll(".gc-details").forEach(e => {
      e.style.backgroundColor = "";
      e.style.color = "";
      e.innerHTML = "";
      //e.classList.remove("in-use")
    })
    this.drawEvents();
  }

  findEvent(event_id) {
    let event = this.events.find(e => {
      return e.id == event_id;
    });
    return event;
  }

  findTableTdByCriterias(date, bay_id, minute, other) {
    let $hour = undefined;
    let $details = undefined;

    if (parseInt(other) !== 0) {
      $hour = this.$element.querySelector(`.gc-hour[bay='${bay_id}'][date='${date}'][other='${other}']`);
      $details = this.$element.querySelector(`.gc-details[bay='${bay_id}'][date='${date}'][other='${other}']`);
    } else {
      $hour = this.$element.querySelector(`.gc-hour[bay='${bay_id}'][date='${date}'][minute='${minute}']`);
      $details = this.$element.querySelector(`.gc-details[bay='${bay_id}'][date='${date}'][minute='${minute}']`);
    }

    return {
      $hour: $hour,
      $details: $details
    }
  }

  refreshColumnData() {
    let that = this;
    this.days = [];
    let maxDays = this.options.days_to_display;
    let today = moment().format("YYYY-MM-DD");
    let dateIteration = moment(this.options.start_date);
    for (let i = 0; i < maxDays; i++) {
      let date = dateIteration.format("YYYY-MM-DD");
      let dateWords = dateIteration.format("dddd DD MMMM").ucFirst();
      dateIteration.add(1, 'day');

      while (this.options.excludeDays.indexOf(dateIteration.day()) !== -1) {
        dateIteration.add(1, 'day');
      }

      this.days.push({
        label: dateWords,
        date: date,
        isToday: date == today,
        isSelected: date == that.options.selected_date,
        columns: that.getFilteredBays().length * 2,
        dayWidth: that.getFilteredBays().length * 260
      })
    }
  }

  getCompiledDays() {
    return this.days;
  }

  getFirstDay() {
    return this.days[0].date;
  }

  getLastDay() {
    return this.days[this.days.length - 1].date;
  }

  getCompiledRows() {
    let that = this;

    let result = [];
    this.options.dayCells.forEach(e => {
      if (e.type == "time") {
        let start = e.start_minute;
        let end = start + e.duration;
        let step = e.step;
        for (let minute = start; minute < end; minute += step) {
          result.push({
            label: that.minutesToHHMM(minute),
            endOfHour: (minute + 15) % 60 == 0,
            minute: minute,
            type: "time"
          })
        }
      } else if (e.type == "other") {
        result.push({
          label: e.label,
          index: e.index,
          type: "other"
        })
      }
    });

    return result;
  }

  getOccupiedData(id) {
    return this.occupiedData[id];
  }

  setOccupiedData(id, details) {
    let lastupdate = details.lastupdate;
    let current = this.getOccupiedData(id);
    if (current !== undefined && current.lastupdate >= lastupdate) {
      return;
    }

    if(details.other !== null){
      // Case autre.
      this.occupiedData[id] = {
        color: "gray",
        slots: [
          {
            date: details.date,
            bay: details.bay,
            other: details.other.split("_")[1]
          }
        ]
      }
    } else {
      let dat = {
        color: "gray",
        slots: []
      };

      let rows = this.getCompiledRows().filter(r => {
        return r.type == "time";
      });

      let days = this.getCompiledDays();

      let dayIx = days.findIndex(d => d.date == details.date);
      let rowIx = rows.findIndex(r => r.minute == details.minute);
      let slotTotal = details.duration / 15;
      let bay = details.bay;

      for(let slotIx = 0; slotIx < slotTotal; slotIx++){

        let row = rows[rowIx];
        let day = days[dayIx];

        if(day === undefined){
          rowIx += 1;
          if(rowIx >= rows.length) {
            rowIx = 0;
            dayIx++;
          }
          continue;
        }

        dat.slots.push({
          date: day.date,
          bay: bay,
          minute: row == null ? 0 : row.minute ?? 0,
        })

        rowIx += 1;
        if(rowIx >= rows.length) {
          rowIx = 0;
          dayIx++;
        }
      }
      
      this.occupiedData[id] = dat;
    }

    this.updateOccupiedDisplay();
  }

  removeOccupiedData(id) {
    if(this.occupiedData[id] !== undefined){
      delete this.occupiedData[id];
      this.updateOccupiedDisplay();
    }
  }

  updateOccupiedDisplay() {
    this.$element.querySelectorAll("td.gc-occupied").forEach(el => {
      el.style.backgroundColor = null;
      el.classList.remove("gc-occupied");
    });

    for (const id in this.occupiedData) {
      const occupied = this.occupiedData[id];
      for (const slot of occupied.slots) {
        if(slot.other !== undefined){
          this.$element.querySelectorAll(`td[bay='${slot.bay}'][date='${slot.date}'][other='${slot.other}']`).forEach(el => {
            el.classList.add("gc-occupied");
            el.style.backgroundColor = occupied.color;
          })
        } else {
          this.$element.querySelectorAll(`td[bay='${slot.bay}'][date='${slot.date}'][minute='${slot.minute}']`).forEach(el => {
            el.classList.add("gc-occupied");
            el.style.backgroundColor = occupied.color;
          })
        }
      }
    }
  }

  /**
   * Annule le dernier mouvement.
   */
  cancelLastMove() {
    this.events = JSON.parse(JSON.stringify(this.lastEventSet));
    for (let tabName in this.tabs) {
      this.tabs[tabName].restoreLastSet();
    }
    this.redrawEvents();
  }

  moveEventTab(event, tabid) {
    if (tabid === "toschedule" && !this.isToScheduleEvent(event)) {
      tabid = null;
    }

    if (event.tabid == null && tabid != null) { // De la grille à un onglet.
      this.tabs[tabid].addEvent(event);
    } else if (event.tabid != null && tabid != null && tabid != event.tabid) { // D'un onglet à un autre.
      this.tabs[event.tabid].removeEvent(event.id);
      this.tabs[tabid].addEvent(event);
    } else if (event.tabid != null && tabid == null) { // D'un onglet à la grille.
      this.tabs[event.tabid].removeEvent(event.id);
    } else if (event.tabid == null && tabid == null) { // Grille à Grille
      for (let tabName in this.tabs) {
        this.tabs[tabName].resetLastSet();
      }
    }

    return tabid;
  }

  moveEvent(event_id, options) {
    this.lastEventSet = JSON.parse(JSON.stringify(this.events));
    let event = this.events.find(e => {
      return e.id == event_id;
    });

    event.bay = options.bay;
    event.date = options.date;
    event.minute = options.minute;
    event.other = options.other;
    let resolvedTabId = this.moveEventTab(event, options.tabid);
    event.tabid = resolvedTabId;
  }

  resizeEvent(event_id, duration) {
    this.lastEventSet = JSON.parse(JSON.stringify(this.events));
    let event = this.events.find(e => {
      return e.id == event_id;
    });
    event.duration = duration;
  }

  minutesToHHMM(minutes) {
    let hour = Math.floor(minutes / 60);
    let minute = minutes - (hour * 60);
    let AmPm = minutes >= 720 ? "PM" : "AM";
    if (hour >= 12) hour -= 12;
    return sprintf(`%02d:%02d %s`, hour, minute, AmPm);
  }

  setupListeners() {

    let that = this;

    //$(this.$element).on("click", ".gc-tab-toggler", e => {
    //    $(e.target).closest(".gc-tab").toggleClass("gc-active");
    //});
	//click sur durée du bon de travail 
	// $(document).on('click','#garage-calendar .gc-details-event .gc-duration',function(){ 
    // $(this.$element).on('click','.gc-duration',function(){ 
    //   let event = $(this).parent.attr("event-id");
    //   window.location = "invoice/view/" + event;
    // });

    $(this.$element).on("click", ".gc-duration", e => {
      let event_id = e.target.parentNode.getAttribute("event-id");
      if (event_id > 0) //ignore background events
      window.location = "invoice/view/" + event_id;
    });
    $(this.$element).on("dblclick", ".gc-details-event", e => {
      let event_id = e.target.getAttribute("event-id");
      if (event_id > 0) //ignore background events
      {
        let event = that.findEvent(event_id);

        let evt2 = new BlockDoubleClickEvent();
        evt2.calendar = that;
        evt2.block = event;
        evt2.clickevent = e;
        that.dispatchEvent("calendar.block.dblclick", evt2);
      }
    });

    $(this.$element).on("dblclick", ".gc-hour,.gc-details", e => {
      let bay = e.target.getAttribute("bay");
      let minute = e.target.getAttribute("minute");
      let date = e.target.getAttribute("date");
      let other = e.target.getAttribute("other");
      if (date === null) return;

      let evt2 = new SlotDoubleClickEvent();
      evt2.calendar = that;
      evt2.slot = {
        bay: bay,
        minute: minute,
        date: date,
        other: other
      };
      evt2.clickevent = e;
      that.dispatchEvent("calendar.slot.dblclick", evt2);
    });

    $(that.options.container).on('scroll', e => {
      that.updateCalendarHeaderPosition();
    });
  }

  updateCalendarHeaderPosition() {
    let elem = this.$element.querySelector(".gc-header-fixed");
    let topScroll = $(this.options.container).scrollTop();
    let leftScroll = $(this.options.container).scrollLeft();
    elem.style.top = topScroll + "px";
    let tabsContainer = this.$element.querySelector("#gc-tabs");
    tabsContainer.style.top = topScroll + "px";
    tabsContainer.style.left = leftScroll + "px";
  }

  getTabEventCount(id) {
    let tab = this.tabs[id];
    return tab.getEvents().length;
  }

  setupDraggable() {

    let that = this;

    let durationStart = 0;
    let moving_event_id = 0;
    let action = undefined;

    let dragtimestamp = 0;

    var thumb;
    var holdOK = false;

    interact(".gc-draggable")
      .pointerEvents({
        holdDuration: 150,
      })
      .on("down", (evt) => {
        holdOK = false;
        evt.target.classList.remove("gc-holding")
      })
      .on("hold", (evt) => {
        holdOK = true;
        evt.target.classList.add("gc-holding")
      })
      .draggable({
        listeners: {
          start(event) {
            if(!holdOK) return;

            thumb = event.target;
            thumb.classList.add('dragging');

            let offsetY = 0;
            if (thumb.classList.contains("gc-tab-event")) {
              offsetY = thumb.offsetTop - thumb.parentNode.scrollTop;
              let $tab = $(thumb).closest(".gc-tab")[0];
              $tab.dataset.open_tab_after = true;
              $tab.classList.remove("gc-active");
              dragtimestamp = Date.now();
            }

            moving_event_id = thumb.getAttribute("event-id");
            let myevent = that.findEvent(moving_event_id);

            thumb.style.position = "absolute";
            thumb.style.top = offsetY + "px";
            thumb.style.left = "0";
            thumb.style.width = "170px";
            thumb.style.height = (that.options.cellHeight * parseInt(myevent.duration / 15)) + "px";
            thumb.style.zIndex = 11;

            that.$element.querySelector(".gc-table-body-wrapper").appendChild(thumb);

            that.cancelLastClick = true;
            action = "drag";
          },
          move(event) {
            if(!holdOK) return;

            var target = thumb,
              x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
              y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform = target.style.transform = `translate(${x}px, ${y}px)`;

            // update the posiion attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
          },
          end(event) {
            if(!holdOK) return;

            holdOK = false;

            $(".dragging").remove();
            setTimeout(t => {
              that.redrawEvents(moving_event_id);
            }, 5);
            action = "resize";
          }
        },
        origin: 'parent',
        autoScroll: {
          container: document.querySelector(that.options.container),
          speed: 800
        },
        ignoreFrom: ".s-resize",
        holdDuration: 250,
      })
      .styleCursor(false)
      .rectChecker(function (checker) {
        let rect = checker.getClientRects();

        if (action === "drag") {
          rect[0].width = 30;
          rect[0].height = 30;
        }

        //return rect[0];
        return {
          left: rect[0].left - 15,
          top: rect[0].top - 15,
          right: rect[0].x + rect[0].width,
          bottom: rect[0].y + rect[0].height,
          width: rect[0].width,
          height: rect[0].height
        };
      })

    let resizeStartHeight = 0;

    interact(".gc-resizable")
      .on("down", (evt) => {
        holdOK = false;
        evt.target.classList.remove("gc-holding")
      })
      .on("hold", (evt) => {
        holdOK = true;
        evt.target.classList.add("gc-holding")
      })
      .resizable({
        edges: {
          top: false,
          left: false,
          bottom: '.s-resize',
          right: false
        },
        autoScroll: {
          container: document.querySelector(that.options.container),
          speed: 800
        },
      })
      
      .on('resizestart', evt => {
        if(!holdOK) return;
        action = "resize";
        let event = that.findEvent(evt.target.getAttribute('event-id'));
        durationStart = event.duration;
        evt.target.dataset["scroll"] = $(that.options.container).scrollTop();
        resizeStartHeight = $(evt.target).height();
      })
      .on('resizemove', evt => {
        if(!holdOK) return;
        let { x, y } = evt.target.dataset;
        y = parseFloat(y) || 0;
        let deltaScroll = $(that.options.container).scrollTop() - evt.target.dataset["scroll"];

        let finalHeight = parseInt((evt.rect.height + (that.options.cellHeight / 2) + deltaScroll) / that.options.cellHeight) * that.options.cellHeight - 1;

        Object.assign(evt.target.style, {
          height: `${finalHeight}px`,
          maxHeight: `${finalHeight}px`,
          transform: `translate(${evt.deltaRect.left}px, ${evt.deltaRect.top}px)`
        })

        Object.assign(evt.target.dataset, { x, y })
      })
      .on('resizeend', evt => {
        if(!holdOK) return;
        let event = that.findEvent(evt.target.getAttribute('event-id'));
        let resizeEndHeight = $(evt.target).height();

        let diffHeight = resizeEndHeight - resizeStartHeight;
        let durationDiff = (parseInt(diffHeight / that.options.cellHeight) * 15);

        that.resizeEvent(evt.target.getAttribute('event-id'), event.duration + durationDiff);

        let evt2 = new BlockChangeEvent();
        evt2.calendar = that;
        evt2.block = event;
        that.dispatchEvent("calendar.block.change", evt2);

        that.redrawEvents();
        action = "resize";

        holdOK = false;
        evt.target.classList.remove("gc-holding")
      })

    interact(".gc-dropzone")
      .dropzone({
        ondrop: function (event) {
          if(!holdOK) return;
          let event_id = event.relatedTarget.getAttribute("event-id");

          event.target.style.backgroundColor = event.target.dataset.oldcolor;
          let tabid = event.target.getAttribute("tab-id");
          let date = event.target.getAttribute("date");
          let bay = event.target.getAttribute("bay");
          let minute = event.target.getAttribute("minute");
          if (minute == undefined) minute = 0;
          let other = event.target.getAttribute("other");
          if (other == undefined) other = 0;
          that.moveEvent(event_id, {
            date: date,
            bay: bay,
            minute: minute,
            other: other,
            tabid: tabid
          });

          let eventobj = that.findEvent(event_id);

          let evt2 = new BlockChangeEvent();
          evt2.calendar = that;
          evt2.block = eventobj;
          that.dispatchEvent("calendar.block.change", evt2);

          that.$element.querySelectorAll(".gc-tab").forEach(e => {
            if (e.dataset.close_tab_after) {
              e.classList.remove("gc-active");
              delete e.dataset.close_tab_after;
            }
            if (e.dataset.open_tab_after) {
              e.classList.add("gc-active");
              delete e.dataset.open_tab_after;
            }
          })

          event.target.classList.remove("gc-holding")
        },
        overlap: 'center',
        accept: ".gc-details-event"
      })
      .on('dragenter', function (event) {
        if(!holdOK) return;
        event.target.dataset.oldcolor = event.target.style.backgroundColor;
        event.target.dataset.oldforecolor = event.target.style.color;
        if (event.target.classList.contains("gc-tab")) {
          if (!event.target.classList.contains("gc-active") && Date.now() > dragtimestamp + 300) {
            event.target.classList.add("gc-active");
            event.target.dataset.close_tab_after = true;
          }
          event.target.style.backgroundColor = "#adffc2";
        } else {
          event.target.style.backgroundColor = "#eee";
        }
      })
      .on('dragleave', function (event) {
        if(!holdOK) return;
        event.target.style.backgroundColor = event.target.dataset.oldcolor;
        event.target.style.color = event.target.dataset.oldforecolor;
      });

    let xy = [10,100];

    interact(".gc-tab").draggable({
      inertia: false,
      listeners: {
        move(event) {

          let target = event.target
          let x = xy[0] + event.dx
          let y = xy[1] + event.dy;

          // translate the element
          target.style.left = `${x}px`;
          target.style.top = `${y}px`;

          // update the posiion attributes
          xy[0] = x;
          xy[1] = y;
        }
      },
      allowFrom: ".gc-tab-header",
      ignoreFrom: ".gc-tab-header-close"
    }).styleCursor(false)

    interact.dynamicDrop(true);

    if (that.options.viewMode) {
      interact(".gc-draggable").draggable(false);
      interact(".gc-draggable").resizable(false);
      interact(".gc-dropzone").dropzone(false);
    }

  }
}